// extracted by mini-css-extract-plugin
export var icon = "EmergencyMessage-module--icon--14f03";
export var message = "EmergencyMessage-module--message--b1a54";
export var wrapper = "EmergencyMessage-module--wrapper--c5571";